import { render } from "./AddPopupModalPage.vue?vue&type=template&id=7c724f0e&scoped=true"
import script from "./AddPopupModalPage.vue?vue&type=script&lang=js"
export * from "./AddPopupModalPage.vue?vue&type=script&lang=js"

import "./AddPopupModalPage.vue?vue&type=style&index=0&id=7c724f0e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c724f0e"]])

export default __exports__